import { Button, QuickEdit } from '../../../../components';

interface LabelAndButtonsRowProps {
  label: string;
  onClickGo: () => void;
  onClickEdit: () => void;
}

export const LabelAndButtonsRow = ({
  label,
  onClickGo,
  onClickEdit,
}: LabelAndButtonsRowProps) => {
  return (
    <section className="flex flex-col gap-3">
      <section className=" flex justify-between items-center">
        <label>{label}</label>
        <section className="flex justify-end w-1/2 gap-4 items-center ">
          <Button
            type="primary"
            className="primary-button w-[180px]"
            onClick={onClickGo}
          >
            Go
          </Button>
          <Button
            type="edit"
            onClick={onClickEdit}
            className="hover:bg-blue rounded-full border-blue border h-7 w-7 p-1"
          >
            <QuickEdit />
          </Button>
        </section>
      </section>

      <hr />
    </section>
  );
};
